import {useState, useEffect, useRef} from 'react'

const originalTitle = document.title

const oldFavicon = new URL('../../public/deloitte_favicons_circular.png', import.meta.url)
const newFavicon = new URL('../../public/exclamation-mark.ico', import.meta.url)

function revertOriginalTitle() {
  document.title = originalTitle
}

function revertOriginalFavIcon() {
  const favicon = document.querySelector("link[rel~='icon']")
  favicon.href = oldFavicon
}

function useTabHighlightNotification() {
  const [message, setMessage] = useState(null)
  const notificationIntervalId = useRef(null)

  function setTabNotification() {
    setMessage(' ' + originalTitle)
    faviconUpdate()
  }

  function clearTabNotification() {
    revertOriginalTitle()
    setMessage(null)
  }

  const faviconUpdate = async () => {
    const favicon = document.querySelector("link[rel~='icon']")
    if (favicon.href.includes('exclamation-mark')) {
      favicon.href = oldFavicon
    } else {
      favicon.href = newFavicon
    }
    notificationIntervalId.current = setTimeout(function () {
      faviconUpdate()
    }, 500)
  }

  function stopNotifying() {
    clearInterval(notificationIntervalId.current)
    revertOriginalFavIcon()
    notificationIntervalId.current = null
  }

  useEffect(() => {
    if (notificationIntervalId.current && !message) stopNotifying()
  }, [message])

  useEffect(() => {
    return () => {
      if (document.title !== originalTitle) revertOriginalTitle()
      revertOriginalFavIcon()
      if (notificationIntervalId.current) clearTimeout(notificationIntervalId.current)
    }
  }, [])

  return [setTabNotification, clearTabNotification]
}

export default useTabHighlightNotification
